// ======================================================================
// File Name       : UserListOnDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { reduxForm, isInvalid, change } from 'redux-form';
import { Table, Col } from 'react-bootstrap';
import ReduxFormPaging from '../ReduxFormPaging';
import TableHead from '../TableHead';
import RenderField from '../../utils/ReduxFormUtils';
import { DORMANT_STATE } from '../../constants';
import { connect } from 'react-redux';

const thead = [
  { title: '', sortBy: null, width: 50 },
  { title: 'ログインID', sortBy: null },
  { title: 'ユーザー名', sortBy: null },
  { title: '所属グループ名', sortBy: null },
];

class UserListOnDialog extends React.Component {
  render() {
    const {
      userList,
      singleSelect,
      maxLength,
      edittingUserList,
      storedEdittingUserList,
      handleChangeCheckbox,
      getStartEndData,
      recordNum,
    } = this.props;
    let count = 0;
    if (edittingUserList) {
      Object.keys(edittingUserList).map((edittingUserId, index) => {
        if (edittingUserList[edittingUserId]) {
          count++;
        }
        return null;
      });
    }
    let tbody = null;
    if (userList && userList.length) {
      tbody = userList.map((user, index) => {
        const disabled =
          (storedEdittingUserList &&
            storedEdittingUserList[user.userSecernId]);
        let disabledByMaxLength = false;
        if (count >= maxLength) { // step6.2
          if (!edittingUserList || !edittingUserList[user.userSecernId]) {
            disabledByMaxLength = true;
          }
        }
        return (
          <tr
            key={index}
            className={
              user.dormantState == DORMANT_STATE.INACTIVE
                ? "inactive-class"
                : ""
            }
          >
            <td
              className="text-center"
              style={{ paddingTop: "0px", paddingBottom: "0px" }}
            >
              {singleSelect ? (
                <RenderField
                  name="edittingUserId"
                  value={user.userSecernId}
                  type="radio"
                  id={user.userSecernId}
                />
              ) : (
                <RenderField
                  name={`edittingUserList.${user.userSecernId}`}
                  value={1}
                  type="checkbox"
                  disabled={disabled || disabledByMaxLength}
                  normalizeCheckBox
                  id={user.userSecernId}
                  radioChange={handleChangeCheckbox}
                  checkRadioChange
                />
              )}
            </td>
            <td className="text-left" style={{ padding: "0px" }}>
              <label
                className="form-label"
                htmlFor={user.userSecernId}
                className="cursor_pointer displayBlock"
                style={{ padding: "8px" }}
              >
                {user.loginId}
              </label>
            </td>
            <td className="text-left" style={{ padding: "0px" }}>
              <label
                className="form-label"
                htmlFor={user.userSecernId}
                className="cursor_pointer displayBlock"
                style={{ padding: "8px" }}
              >
                {user.userName}
              </label>
            </td>
            <td className="text-left" style={{ padding: "0px" }}>
              <label
                className="form-label"
                htmlFor={user.userSecernId}
                className="cursor_pointer displayBlock"
                style={{ padding: "8px" }}
              >
                {user.groupNames}
              </label>
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Table striped hover>
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
        <Col sm={12} className="text-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
          />
        </Col>
      </div>
    );
  }
}

export default UserListOnDialog;
